import * as axiosService from "./axiosService";


export const SignUpUser = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/SignUpUser`, payload);
};


export const SaveKYCInfo = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/Account/SaveUserKycInfo`, payload);
};


export const setPin = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_AUTH_API_URL + `/User/SetPin`, payload);
};

export const ChangePin = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/User/ChangePin`, payload);
};

export const verifyOTP = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/VerifyOtp`, payload);
};
